if (($('.sidebarlinks').text() || '').trim() === '') {
	$('.sidebarlinks').addClass('d-none');
	$('.maincontentrechts').css({ 'flex-basis': '100%', 'max-width': '100%' });
}
